export default __webpack_public_path__ + "static/mg-service01-334efc228021194cc7b7a2d5c5c23bfe.jpg";